import React from "react";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { PHASES, IMAGES } from "./hcaData";
import { HcaReveal, HcaEyebrow } from "./HcaReveal";

const CourseRow = ([code, name, hours]) => (
    <li key={code} className="flex items-center justify-between gap-4 py-3.5 border-b border-[#D8DEE6] last:border-0">
        <div className="flex items-center gap-4 min-w-0">
            <span className="font-mono text-xs text-[#D4A140] w-12 shrink-0">{code}</span>
            <span className="text-sm text-[#0E1E3A]">{name}</span>
        </div>
        <span className="text-sm font-semibold text-[#0E1E3A] tabular-nums shrink-0">{hours}h</span>
    </li>
);

export const HcaCurriculum = () => (
    <section data-testid="hca-curriculum-section" className="max-w-7xl mx-auto px-6 py-20 lg:py-28 grid lg:grid-cols-12 gap-12">
        <HcaReveal className="lg:col-span-5">
            <HcaEyebrow>What you'll learn</HcaEyebrow>
            <h2 className="font-display text-3xl sm:text-4xl text-[#0E1E3A] mt-3 leading-tight">
                769 hours. Three phases. One rewarding career.
            </h2>
            <p className="text-[#5E6B7E] mt-4 leading-relaxed">
                Learn personal care, mobility and feeding support, communication, assisting with medication
                delivery and clinical skills — then put it all into practice with real clients.
            </p>
            <img src={IMAGES.lab} alt="Health care assistant supporting a senior client" className="mt-8 rounded-2xl aspect-[4/3] w-full object-cover" />
        </HcaReveal>
        <HcaReveal delay={0.1} className="lg:col-span-7">
            <Tabs defaultValue="phase-1">
                <TabsList className="w-full grid grid-cols-3 h-auto bg-[#F0EDE6] p-1 rounded-full">
                    {PHASES.map((p) => (
                        <TabsTrigger key={p.id} value={p.id} data-testid={`hca-curriculum-tab-${p.id}`} className="rounded-full py-2.5 data-[state=active]:bg-[#0E1E3A] data-[state=active]:text-white">
                            {p.tab}
                        </TabsTrigger>
                    ))}
                </TabsList>
                {PHASES.map((p) => (
                    <TabsContent key={p.id} value={p.id} className="mt-6 rounded-2xl bg-white border border-[#D8DEE6] p-6 sm:p-8" data-testid={`hca-curriculum-panel-${p.id}`}>
                        <div className="flex items-baseline justify-between mb-2">
                            <h3 className="font-display text-xl text-[#0E1E3A]">{p.title}</h3>
                            <span className="text-xs uppercase tracking-[0.18em] text-[#5E6B7E]">{p.hours} hours</span>
                        </div>
                        <ul>{p.courses.map(CourseRow)}</ul>
                    </TabsContent>
                ))}
            </Tabs>
        </HcaReveal>
    </section>
);
